/** @format */

import { isA23 } from "../Stats";
import styles from "../Stats.module.css";
import gameAssets from "@themed-assets";

export default function PlayPosition({ title, data, handPlayed }) {
  return (
    <>
      {data && Object.keys(data).length > 0 && (
        <div className="mt-[24px] relative">
          <div className="text-base font-medium mb-3">{title}</div>
          <img
            src={gameAssets.statsPlayerTable}
            className={styles.statsPlayTable}
            alt="Tournament prize"
          />
          <div className={`${styles.statCard}`}>
            <div className={`text-center mb-15`}>
              <span className="text-xs text-secondary">
                Total Hands Played{" "}
              </span>
              <span className="ont-bold text-[14px]">{handPlayed || ""}</span>
            </div>
            <div className="text-center flex flex-col gap-4">
              <div className={`${styles.flopSeen} w-[72px]`}>
                <div className="text-[10px] text-secondary">Flops Seen</div>
                <div className="font-bold text-[14px]">{data.total}</div>
              </div>
              <div className="flex justify-between z-1">
                <div className={styles.statPlayCard}>
                  <div className="font-bold text-[14px]">{data.onSB} %</div>
                  <div className="text-xs text-secondary">On SB</div>
                </div>
                <div className={styles.statPlayCard}>
                  <div className="font-bold text-[14px]">{data.onBB} %</div>
                  <div className="text-xs text-secondary">On BB</div>
                </div>
              </div>
              <div className="flex justify-evenly z-1">
                <div className={styles.statPlayCard}>
                  <div className="font-bold text-[14px]">{data.others} %</div>
                  <div className="text-xs text-secondary">Others</div>
                </div>
                <div className={styles.statPlayCard}>
                  <div className="font-bold text-[14px]">{data.onButton} %</div>
                  <div className="text-xs text-secondary">On Button</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
